var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-4 pl-2 d-flex align-center",attrs:{"fluid":""}},[_c('v-img',{staticClass:"pa-3 rounded-0",staticStyle:{"margin":"auto","cursor":"pointer"},attrs:{"contain":"","src":"/img/ciderWorldServiceLogo.png","alt":"CiderWorld Service Logo","max-width":"160px","transition":"fade-transition"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }